import MapUtilService from "./MapUtilService";
import isEmpty from "lodash/isEmpty";
import _ from "lodash";
import { LIST_LICENSE_PLATE_MULTIPLE } from "app/modules/truck/_redux/constants";

const mapUtilService = new MapUtilService();

export default {
  getList: param => {
    let api = `/api/vehicle/search?`;
    if (!isEmpty(param.data)) {
      api = api + `&license_plate=${param.data}`;
    }
    if (!isEmpty(param.status)) {
      api = api + `&status=${param.status}`;
    }
    return mapUtilService.get(api);
  },
  getListManage: param => {
    let api = `/api/vehicle/search?limit=${param.limit ??
      20}&offset=${param.offset ?? 1}`;
    if (param.license_plate) {
      api = api + `&license_plate=${param.license_plate}`;
    }
    if (!isEmpty(param.station_id)) {
      api = api + `&station_id=${param.station_id}`;
    }
    if (!isEmpty(param.status)) {
      api = api + `&status=${param.status}`;
    }
    return mapUtilService.get(api);
  },
  addVehicle: data => {
    let api = `/api/vehicle/add_vehicle`;
    return mapUtilService.post(api, data);
  },
  getDetail: function(param) {
    let api = `/api/vehicle/getVehicleByCode?code=${param.data}`;
    return mapUtilService.get(api);
  },
  getTruckJourney: function(param) {
    let api = `/api/vehicle/getVehicleRoute/${param.licensePlate ||
      param.license_plate}?from=${param.from}&to=${param.to}`;
    return mapUtilService.get(api);
  },
  getListLicensePlate: function() {
    let api = `/api/vehicle/getListLicensePlate`;
    return mapUtilService.get(api);
  },
  getTotalManageTruck: function() {
    let api = `/api/vehicle/getTotalVehicle`;
    return mapUtilService.get(api);
  },
  getManageMap: function(param) {
    let api = `/api/vehicle/search?limit=${param.limit}&offset=${param.page}`;

    if (!isEmpty(param.stationVal)) {
      api = api + `&station_id=${param.stationVal}`;
    }
    if (!isEmpty(param.statusVal)) {
      api = api + `&status=${param.statusVal}`;
    }
    if (!isEmpty(param.license_plate)) {
      api = api + `&license_plate=${param.license_plate}`;
    }
    return mapUtilService.get(api);
  },
  getVehicleStatus: function(param) {
    let api = `/api/vehicle/getVehicleStatus?`;

    if (!isEmpty(param.stationVal)) {
      api = api + `&station_id=${param.stationVal}`;
    }
    if (!isEmpty(param.statusVal)) {
      api = api + `&status=${param.statusVal}`;
    }
    if (!isEmpty(param.license_plate)) {
      api = api + `&license_plate=${param.license_plate}`;
    }
    return mapUtilService.get(api);
  },
  updateVehicleTracker: data => {
    let api = `/api/vehicle/updateVehicleTracker`;
    return mapUtilService.post(api, data);
  },
  deleteVehicle: data => {
    let api = `/api/vehicle/deleteVehicle`;
    return mapUtilService.post(api, data);
  },
  listDriver: function() {
    let api = `/api/user/listDriver`;
    return mapUtilService.get(api);
  },
  createTruck: function(data) {
    let api = `api/vehicle/addVehicle`;
    return mapUtilService.post(api, data);
  },
  searchTruckerByUserName: function(param) {
    let api = `/api/driver/search`;
    return mapUtilService.get(api, { params: param });
  },
  getReportInfo: function(report_type, param) {
    const DRIVER_TIME_FROM_DEFAULT = 0;
    let license_plate = param.license_plate
      ? typeof param.license_plate === "string"
        ? param.license_plate
        : _.includes(LIST_LICENSE_PLATE_MULTIPLE, report_type)
          ? _.size(param.license_plate)
            ? param.license_plate
            : undefined
          : _.size(param.license_plate)
            ? param.license_plate[0]
            : undefined
      : undefined;
    let api;
    switch (report_type) {
      case "type1": {
        api = `/api/report/tt09/reportViolateByVehicle?`;
        break;
      }

      case "type2": {
        api = `/api/report/tt09/reportSpeedViolateByCompany?`;
        break;
      }

      case "type3": {
        api = `/api/report/tt09/violateDrivingContinuous?`;
        api =
          api +
          `&drive_time_from=${
            param.drive_time_from
              ? param.drive_time_from
              : DRIVER_TIME_FROM_DEFAULT
          }`;
        break;
      }

      case "type4": {
        api = `api/report/tt09/violateDrivingInDay?`;
        break;
      }
      case "type5": {
        api = `/api/report/tt09/violateSummaries?`;
        break;
      }
      case "type6": {
        api = `/api/report/tt09/violateTransfer?`;
        break;
      }
    }
    if (param.from_date) {
      api = api + `&from_date=${param.from_date}`;
    }
    if (param.to_date) {
      api = api + `&to_date=${param.to_date}`;
    }
    if (license_plate) {
      api = api + `&license_plate=${license_plate}`;
    } else {
      api = api + `&license_plate=all`;
    }
    if (param.limit) {
      api = api + `&limit=${param.limit}`;
    }
    if (param.offset) {
      api = api + `&offset=${param.offset}`;
    }
    if (param.download_flg) {
      api = api + `&download_flg=${param.download_flg}`;
    }
    return mapUtilService.get(api);
  },
  getFirmwareInfo(param) {
    let api = `device/firmware`;
    return mapUtilService.get(api, { params: param });
  },
  getDeviceInfo(param) {
    let api = `/api/ota/listDevice`;
    return mapUtilService.get(api, { params: param });
  },
  deleteFirmware(param) {
    let api = `api/ota/deleteFW`;
    return mapUtilService.get(api, { params: param });
  },
  editFirmware(param) {
    let api = `/api/ota/updateDevice`;
    return mapUtilService.get(api, { params: param });
  },
  createDevice(param) {
    let api = `api/ota/addImei`;
    return mapUtilService.get(api, { params: param });
  },
  getFirmwareDetailByPage(page, param) {
    let api = `api/ota/getPage/${page}`;
    return mapUtilService.get(api, { params: param });
  }
};
